import React from "react";
import { motion } from "framer-motion";
import { Film, Play } from "lucide-react";
import { useNavigate } from "react-router-dom";

const IkiTube = () => {
    const navigate = useNavigate();
    return (
        <section className="relative py-24 bg-[#0F0F0F] overflow-hidden">
            {/* Ambient Glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-purple-600/10 rounded-full blur-3xl -z-10" />

            <div className="max-w-4xl mx-auto px-6 text-center flex flex-col items-center justify-center">
                {/* Title */}
                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-4xl md:text-6xl font-extrabold text-white mb-6 flex flex-row justify-center items-center align-center gap-3"
                >
                    <Film size={50} />
                    Try <span className="text-[#2F8F6F]">IkiTube</span>
                </motion.h2>

                {/* Description */}
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2, duration: 0.6 }}
                    className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed"
                >
                    Explore my creative world of cinematic videos, visual stories,
                    and experimental projects. A personal space where technology
                    meets imagination.
                </motion.p>

                {/* Button */}
                <motion.button
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.4, duration: 0.5 }}
                    whileHover={{
                        scale: 1.05,
                        boxShadow: "0 0 40px #2F8F6F"
                    }}
                    whileTap={{ scale: 0.95 }}
                    className=" px-5 py-2.5
                    rounded-full
                    bg-white/10
                    backdrop-blur-xl
                    border border-[#2F8F6F]/30
                    text-[#D7C7A1]
                    hover:bg-[#2F8F6F]/20
                    hover:text-white
                    hover:border-[#2F8F6F]
                    transition-all duration-300
                    shadow-md shadow-[#145A43]/20
                    text-lg
                    flex
                    flex-row
                    self-center
                    justify-self-center
                    gap-3
                    font-bold
                    items-center"
                    onClick={() => {
                        navigate('ikiTube');
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                    }}
                >
                    <Play className="w-5 h-5 fill-white" />
                    IkiTube
                </motion.button>
            </div>
        </section>
    );
};

export default IkiTube;